<div class="content-wrapper-parent">
  <div class="content-wrapper">
    <div class="activity-content">
      <div class="page-header">
        <h1>Users</h1>
        <div class="header-actions-right">
          <mat-form-field class="search-box" appearance="outline">
            <mat-icon matPrefix svgIcon="search"></mat-icon>
            <input matInput placeholder="Search users..." [(ngModel)]="searchQuery" (ngModelChange)="applyFilter($event)">
            <button *ngIf="searchQuery" matSuffix mat-icon-button aria-label="Clear search" (click)="clearSearch()"><mat-icon>close</mat-icon></button>
          </mat-form-field>
          <button mat-raised-button color="primary" class="add-btn" (click)="openUserDialog()">New User</button>
        </div>
      </div>
      <div class="table-wrapper">
        <div class="activity-table-container table-container">
          <table mat-table [dataSource]="dataSource" matSort #sortTable="matSort" class="activity-table">
            <ng-container matColumnDef="icon">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let user" class="icon-cell"><mat-icon [svgIcon]="getUserIcon()" class="activity-icon"></mat-icon></td>
            </ng-container>
            <ng-container matColumnDef="userName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
              <td mat-cell *matCellDef="let user" class="activity-name">{{ user.userName }}</td>
            </ng-container>
            <ng-container matColumnDef="firstName"><th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th><td mat-cell *matCellDef="let user">{{ user.firstName || '-' }}</td></ng-container>
            <ng-container matColumnDef="lastName"><th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th><td mat-cell *matCellDef="let user">{{ user.lastName || '-' }}</td></ng-container>
            <ng-container matColumnDef="roleName"><th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th><td mat-cell *matCellDef="let user">{{ user.roleName }}</td></ng-container>
            <ng-container matColumnDef="productName"><th mat-header-cell *matHeaderCellDef mat-sort-header>Product</th><td mat-cell *matCellDef="let user">{{ user.productName || '-' }}</td></ng-container>
            <ng-container matColumnDef="activeYN"><th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th><td mat-cell *matCellDef="let user">{{ user.activeYN ? 'Active' : 'Inactive' }}</td></ng-container>
            <ng-container matColumnDef="addedAt"><th mat-header-cell *matHeaderCellDef mat-sort-header>Added At</th><td mat-cell *matCellDef="let user">{{ formatDate(user.addedAt) }}</td></ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let user" class="actions-cell">
                <!-- <button mat-icon-button class="action-btn" (click)="openUserDialog(user)" matTooltip="Edit user" aria-label="Edit user"><mat-icon svgIcon="pencil-blue"></mat-icon></button> -->
                <button *ngIf="!isCurrentUser(user)" mat-icon-button class="action-btn" (click)="deleteUser(user)" matTooltip="Delete user" aria-label="Delete user"><mat-icon svgIcon="delete"></mat-icon></button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" class="activity-row"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>